import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CycleList from './CycleList';
import CycleForm from './CycleForm';
import DeletedCyclesList from './DeletedCyclesList';

const Cycles = () => {
  return (
    <Routes>
      <Route path="/" element={<CycleList />} />
      <Route path="/new" element={<CycleForm />} />
      <Route path="/:id/edit" element={<CycleForm />} />
      <Route path="/deleted" element={<DeletedCyclesList />} />
      <Route path="*" element={<Navigate to="/cycles" replace />} />
    </Routes>
  );
};

export default Cycles;
